// Date of birth helpers.
// dob is stored as a string and may be in any of these formats:
//  - YYYY-MM-DD from registration and admin edits, e.g. "1990-05-15"
//  - legacy ISO datetime from older registrations, e.g. "1990-05-14T23:00:00.000Z"
//  - legacy DD/MM/YYYY from older admin edits, e.g. "15/05/1990"

// legacy ISO datetimes are read in Nigerian time, matching the birthday cron
const APP_TIMEZONE = "Africa/Lagos";

// parse a stored dob into a local Date object (or null if invalid)
export const parseDob = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const str = String(value).trim();

  // legacy DD/MM/YYYY
  const dmy = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dmy) {
    return new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
  }

  // YYYY-MM-DD (parse as local date, not UTC)
  const ymd = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (ymd) {
    return new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
  }

  // legacy ISO datetime: take its calendar date in APP_TIMEZONE
  const date = new Date(str);
  if (isNaN(date.getTime())) return null;

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: APP_TIMEZONE,
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).formatToParts(date);
  const getPart = (type) => Number(parts.find((part) => part.type === type).value);

  return new Date(getPart("year"), getPart("month") - 1, getPart("day"));
};

// format a stored dob for display as DD/MM/YYYY
export const formatDob = (value) => {
  const date = parseDob(value);
  if (!date) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// convert a Date object into the stored dob format (YYYY-MM-DD)
export const toDobString = (date) => {
  if (!date) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};
